// Shipping Timeline Handler
// Displays shipping estimates based on customer's country from GLC app

(function() {
  // Make shippingTimeline global so it persists across cart updates
  if (!window.shippingTimelineHandler) {
    window.shippingTimelineHandler = {
      // Standard shipping: 13-18 days globally (10-15 days + 3 days handling)
      // Exception: India gets 5-7 days
      standard: {
        global: '13-18 business days',
        india: '5-7 business days'
      },
      
      // Expedited shipping by region
      expedited: {
        fast: '3-5 business days', // USA, Europe, UK, North America, Asia, Australia, New Zealand, East Asia
        medium: '5-7 business days' // South America, Africa, Iceland, Russia
      },
      
      // Country to region mapping
      regions: {
        fast: [
          'US', 'CA', 'MX', // North America
          'GB', 'IE', 'FR', 'DE', 'IT', 'ES', 'PT', 'NL', 'BE', 'LU', 'AT', 'CH', 'DK', 'SE', 'NO', 'FI', 'PL', 'CZ', 'SK', 'HU', 'RO', 'BG', 'GR', 'HR', 'SI', 'EE', 'LV', 'LT', 'MT', 'CY', // Europe & UK
          'AU', 'NZ', // Australia & New Zealand
          'JP', 'KR', 'CN', 'HK', 'TW', 'SG', 'MY', 'TH', 'VN', 'PH', 'ID', 'IN', 'PK', 'BD', 'LK', 'NP', 'MM', 'KH', 'LA', 'BN', 'MO', 'MN', 'KZ', 'UZ', 'TM', 'TJ', 'KG', 'AE', 'SA', 'IL', 'JO', 'LB', 'TR', 'IQ', 'IR', 'OM', 'KW', 'BH', 'QA', 'YE', 'SY', 'AM', 'GE', 'AZ' // Asia & East Asia & Middle East
        ],
        medium: [
          'BR', 'AR', 'CL', 'CO', 'PE', 'VE', 'EC', 'BO', 'PY', 'UY', 'GY', 'SR', 'GF', // South America
          'ZA', 'NG', 'EG', 'KE', 'ET', 'TZ', 'UG', 'DZ', 'SD', 'MA', 'AO', 'GH', 'MZ', 'MG', 'CM', 'CI', 'NE', 'BF', 'ML', 'MW', 'ZM', 'SN', 'SO', 'TD', 'GN', 'RW', 'BJ', 'TN', 'BI', 'SS', 'TG', 'SL', 'LY', 'LR', 'MR', 'CF', 'ER', 'GM', 'BW', 'GA', 'NA', 'LS', 'GW', 'GQ', 'MU', 'SZ', 'DJ', 'RE', 'KM', 'CV', 'ST', 'SC', // Africa
          'IS', // Iceland
          'RU', 'BY', 'UA', 'MD' // Russia & nearby
        ]
      },
      
      cachedCountryCode: null,
      
      getCountryCode: function() {
        console.log('[Shipping Timeline] Getting country code...');
        console.log('[Shipping Timeline] All localStorage keys:', Object.keys(localStorage));
        
        // Return cached value if available
        if (this.cachedCountryCode) {
          console.log('[Shipping Timeline] Using cached country code:', this.cachedCountryCode);
          return this.cachedCountryCode;
        }
        
        let countryCode = null;
        
        // Method 1: Check localStorage for glc_switcher (GLC app)
        try {
          const glcSwitcher = localStorage.getItem('glc_switcher');
          console.log('[Shipping Timeline] glc_switcher raw value:', glcSwitcher);
          if (glcSwitcher) {
            const data = JSON.parse(glcSwitcher);
            console.log('[Shipping Timeline] glc_switcher parsed:', data);
            if (data.value && data.value.country) {
              countryCode = data.value.country;
              console.log('[Shipping Timeline] Country from glc_switcher:', countryCode);
            }
          }
        } catch (e) {
          console.log('[Shipping Timeline] GLC switcher check failed:', e);
        }
        
        // Method 2: Check localStorage for geolocalization (alternative)
        if (!countryCode) {
          try {
            const glcData = localStorage.getItem('geolocalization');
            console.log('[Shipping Timeline] geolocalization value:', glcData);
            if (glcData) {
              const data = JSON.parse(glcData);
              countryCode = data.country || data.countryCode || data.country_code;
              console.log('[Shipping Timeline] Country from geolocalization:', countryCode);
            }
          } catch (e) {
            console.log('[Shipping Timeline] GLC localStorage check failed:', e);
          }
        }
        
        // Method 3: Check for GLC cookie
        if (!countryCode) {
          const cookies = document.cookie.split(';');
          console.log('[Shipping Timeline] All cookies:', document.cookie);
          for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === 'glc_country' || name === 'geolocalization_country') {
              countryCode = value;
              console.log('[Shipping Timeline] Country from cookie:', countryCode);
              break;
            }
          }
        }
        
        // Method 4: Check window object (some GLC implementations)
        if (!countryCode && typeof window.Shopify !== 'undefined' && window.Shopify.country) {
          countryCode = window.Shopify.country;
          console.log('[Shipping Timeline] Country from Shopify object:', countryCode);
        }
        
        // Method 5: Try to get from Shopify's localization (backup)
        if (!countryCode && typeof Shopify !== 'undefined' && Shopify.Checkout) {
          countryCode = Shopify.Checkout.country;
          console.log('[Shipping Timeline] Country from Shopify.Checkout:', countryCode);
        }
        
        // Default to US if no country detected
        if (!countryCode) {
          countryCode = 'US';
          console.log('[Shipping Timeline] No country detected, defaulting to US');
        }
        
        // Cache the result
        this.cachedCountryCode = countryCode;
        console.log('[Shipping Timeline] Final country code:', countryCode);
        return countryCode;
      },
      
      getExpeditedTimeline: function(countryCode) {
        countryCode = countryCode.toUpperCase();
        
        if (this.regions.fast.includes(countryCode)) {
          return this.expedited.fast;
        } else if (this.regions.medium.includes(countryCode)) {
          return this.expedited.medium;
        } else {
          // Default to fast for any unlisted countries
          return this.expedited.fast;
        }
      },
      
      getStandardTimeline: function(countryCode) {
        countryCode = countryCode.toUpperCase();
        
        if (countryCode === 'IN') {
          return this.standard.india;
        } else {
          return this.standard.global;
        }
      },
      
      updateTimeline: function(countryCode) {
        console.log('[Shipping Timeline] Updating timeline for country:', countryCode);
        
        // Find all shipping timeline containers (in case of multiple carts)
        const containers = document.querySelectorAll('.shipping-timeline');
        console.log('[Shipping Timeline] Found containers:', containers.length);
        
        containers.forEach(function(container, index) {
          console.log('[Shipping Timeline] Processing container #' + index);
          
          const loadingDiv = container.querySelector('.shipping-timeline__loading');
          const optionsDiv = container.querySelector('.shipping-timeline__options');
          const standardElement = container.querySelector('[data-timeline-type="standard"] .shipping-timeline__days-text');
          const expeditedElement = container.querySelector('[data-timeline-type="expedited"] .shipping-timeline__days-text');
          const standardPriceElement = container.querySelector('[data-price-type="standard"] .shipping-timeline__price-text');
          const expeditedPriceElement = container.querySelector('[data-price-type="expedited"] .shipping-timeline__price-text');
          
          console.log('[Shipping Timeline] Elements found:', {
            loadingDiv: !!loadingDiv,
            optionsDiv: !!optionsDiv,
            standardElement: !!standardElement,
            expeditedElement: !!expeditedElement,
            standardPriceElement: !!standardPriceElement,
            expeditedPriceElement: !!expeditedPriceElement
          });
          
          if (loadingDiv && optionsDiv && standardElement && expeditedElement) {
            // Set timelines
            const standardTime = window.shippingTimelineHandler.getStandardTimeline(countryCode);
            const expeditedTime = window.shippingTimelineHandler.getExpeditedTimeline(countryCode);
            
            console.log('[Shipping Timeline] Setting times - Standard:', standardTime, 'Expedited:', expeditedTime);
            
            standardElement.textContent = standardTime;
            expeditedElement.textContent = expeditedTime;
            
            // Fetch and display shipping rates
            window.shippingTimelineHandler.fetchAndDisplayRates(container, countryCode, standardPriceElement, expeditedPriceElement);
            
            // Show options, hide loading
            loadingDiv.style.display = 'none';
            optionsDiv.style.display = 'block';
            
            console.log('[Shipping Timeline] Timeline updated successfully for container #' + index);
          } else {
            console.log('[Shipping Timeline] Missing elements in container #' + index);
          }
        });
      },
      
      fetchAndDisplayRates: async function(container, countryCode, standardPriceEl, expeditedPriceEl) {
        try {
          // Use the fetchShippingRates function from payment-flow if available
          if (typeof fetchShippingRates === 'function') {
            console.log('[Shipping Timeline] Fetching shipping rates for', countryCode);
            const shippingInfo = await fetchShippingRates(countryCode);
            
            if (shippingInfo && shippingInfo.rates) {
              console.log('[Shipping Timeline] Got shipping rates:', shippingInfo.rates);
              
              // Try to match rates by name (case-insensitive)
              const standardRate = shippingInfo.rates.find(r => 
                r.name.toLowerCase().includes('standard')
              );
              const expeditedRate = shippingInfo.rates.find(r => 
                r.name.toLowerCase().includes('expedited') || 
                r.name.toLowerCase().includes('express')
              );
              
              // Store rates in container for later use
              container.dataset.shippingRates = JSON.stringify(shippingInfo.rates);
              
              // Display prices
              if (standardRate && standardPriceEl) {
                standardPriceEl.textContent = this.formatPrice(standardRate.price, shippingInfo.currency);
              }
              if (expeditedRate && expeditedPriceEl) {
                expeditedPriceEl.textContent = this.formatPrice(expeditedRate.price, shippingInfo.currency);
              }
            } else {
              console.log('[Shipping Timeline] No shipping rates available');
              if (standardPriceEl) standardPriceEl.textContent = 'Calculated at checkout';
              if (expeditedPriceEl) expeditedPriceEl.textContent = 'Calculated at checkout';
            }
          } else {
            console.log('[Shipping Timeline] fetchShippingRates not available');
            if (standardPriceEl) standardPriceEl.textContent = '';
            if (expeditedPriceEl) expeditedPriceEl.textContent = '';
          }
        } catch (error) {
          console.error('[Shipping Timeline] Error fetching rates:', error);
          if (standardPriceEl) standardPriceEl.textContent = '';
          if (expeditedPriceEl) expeditedPriceEl.textContent = '';
        }
      },
      
      formatPrice: function(price, currency) {
        // Price is already in the correct currency, just format it
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency || 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        
        // Convert from cents to dollars if needed
        const priceValue = price >= 100 ? price / 100 : price;
        return formatter.format(priceValue);
      },
      
      init: function() {
        console.log('[Shipping Timeline] Initializing...');
        const countryCode = this.getCountryCode();
        console.log('[Shipping Timeline] About to update timeline with country:', countryCode);
        this.updateTimeline(countryCode);
        console.log('[Shipping Timeline] Init complete');
      }
    };
  }
  
  // Initialize with retries to handle AJAX cart updates
  console.log('[Shipping Timeline] Script loaded');
  
  function initWithRetry(attempts) {
    attempts = attempts || 0;
    console.log('[Shipping Timeline] Init attempt #' + attempts);
    
    const containers = document.querySelectorAll('.shipping-timeline');
    console.log('[Shipping Timeline] Found ' + containers.length + ' containers');
    
    if (containers.length > 0) {
      // Clear cache on fresh initialization to re-read country data
      window.shippingTimelineHandler.cachedCountryCode = null;
      
      try {
        window.shippingTimelineHandler.init();
        console.log('[Shipping Timeline] Init completed for attempt #' + attempts);
      } catch (e) {
        console.error('[Shipping Timeline] Init failed:', e);
      }
      
      // Retry with delays to handle async localStorage updates
      if (attempts < 3) {
        var delays = [300, 800, 2000];
        setTimeout(function() {
          console.log('[Shipping Timeline] Running retry #' + (attempts + 1));
          window.shippingTimelineHandler.cachedCountryCode = null;
          window.shippingTimelineHandler.init();
        }, delays[attempts]);
      }
    } else {
      console.log('[Shipping Timeline] No containers found, will retry');
      if (attempts < 10) {
        setTimeout(function() {
          initWithRetry(attempts + 1);
        }, 100);
      }
    }
  }
  
  // Run immediately first, then with slight delay
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initWithRetry(0);
    });
  } else {
    initWithRetry(0);
  }
  
  // Watch for DOM changes (cart updates)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      const hasShippingTimeline = mutations.some(function(mutation) {
        return mutation.addedNodes && Array.from(mutation.addedNodes).some(function(node) {
          return node.classList && (node.classList.contains('shipping-timeline') || 
                 (node.querySelector && node.querySelector('.shipping-timeline')));
        });
      });
      
      if (hasShippingTimeline) {
        console.log('[Shipping Timeline] DOM change detected, re-initializing');
        // Clear cache to force re-reading country data
        window.shippingTimelineHandler.cachedCountryCode = null;
        setTimeout(function() {
          window.shippingTimelineHandler.init();
        }, 100);
      }
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    console.log('[Shipping Timeline] MutationObserver started');
  }
  
  // Listen for custom cart events if available
  document.addEventListener('DOMContentLoaded', function() {
    // Watch for cart drawer opening/rendering
    const cartDrawerElement = document.querySelector('cart-drawer');
    if (cartDrawerElement) {
      // Override renderContents to trigger our update
      const originalRenderContents = cartDrawerElement.renderContents;
      if (originalRenderContents) {
        cartDrawerElement.renderContents = function() {
          const result = originalRenderContents.apply(this, arguments);
          console.log('[Shipping Timeline] Cart drawer rendered, updating timeline');
          setTimeout(function() {
            window.shippingTimelineHandler.cachedCountryCode = null;
            window.shippingTimelineHandler.init();
          }, 150);
          return result;
        };
      }
    }
  });
})();
